import Box from '@mui/material/Box';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { PerformanceReportView } from '../../../components/reports/performance/PerformanceReportView.js';
import { useReportScope } from '../../../components/reports/ReportScope.js';

function PerformanceReportPage(): ReactNode {
  const scope = useReportScope();

  return (
    <Box sx={{ px: 6, py: 4 }}>
      <PerformanceReportView request={scope} />
    </Box>
  );
}

export const Route = createFileRoute('/reports/performance/')({
  component: PerformanceReportPage,
});
